<template>
  <div id="app"><router-view v-if="isRouterAlive"></router-view></div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  watch: {
    $route(to, from) {
      const code = to.query.code
      if (code && code !== 'undefined' && code !== 'null') {
        this.updateCode(code)
        this.getChannelByCode(code)
      }
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    ...mapActions('home', ['getChannelByCode']),
    ...mapMutations('home', ['updateCode']),
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  },
  created() {}
}
</script>
<style lang="less">
@import '../static/css/main.less';
</style>



// WEBPACK FOOTER //
// src/App.vue